import { Message } from "element-ui";
import moment from "moment";

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    search() {
      if (this.$refs["SearchByMemberAndCard2"]) {
        let params = this.$refs["SearchByMemberAndCard2"].params;
        // this.params.memberType = params.memberType;
        if (params.phone) {
          if (params.phone.length > 8 && params.phone.length != 11) {
            Message.error("请输入11位的手机号~");
            return;
          }
          this.params.phone = params.phone;
        } else {
          this.params.phone = undefined;
        }
      }
      if (this.time && this.time.length === 2) {
        console.log(this.time);
        if (this.time[0] === this.time[1]) {
          this.params.startTime = this.time[0] / 1000;
          this.params.endTime = moment(this.time[0]).add(1, "days").format("X");
        } else {
          this.params.startTime = this.time[0] / 1000;
          this.params.endTime = moment(this.time[1]).add(1, "days").format("X");
        }
      } else {
        delete this.params.startTime;
        delete this.params.endTime;
      }
      if (this.$refs["params"]) {
        this.$refs["params"].validate((valid) => {
          if (valid) {
            this.current = 1;
            this.fetchData();
          } else {
            return false;
          }
        });
      } else {
        this.current = 1;
        this.fetchData();
      }
    },
    reset(config) {
      if (this.$refs["SearchByMemberAndCard2"]) {
        this.$refs["SearchByMemberAndCard2"].params.phone = "";
        this.params.phone = undefined;
        // this.params.memberType = undefined;
      }
      let notResetFieldsMap = null;
      // 如果有不需要重置的字段列表
      if (config.notResetFields && Array.isArray(config.notResetFields)) {
        notResetFieldsMap = new Map();
        config.notResetFields.map(
          (f) => f in this.params && notResetFieldsMap.set(f, this.params[f])
        );
      }
      if (this.$refs["params"]) {
        this.$refs["params"].resetFields();
      }
      if (this.resetFields) {
        this.resetFields();
      }
      if (this.time) {
        delete this.params.startTime;
        delete this.params.endTime;
        this.time = [];
        this.current = 1;
      }
      if (this.$refs["lpDatePicker"]) {
        this.$refs["lpDatePicker"].resetDate();
      }
      // 恢复不需要重置的字段值
      if (notResetFieldsMap) {
        [...notResetFieldsMap.entries()].map(([k, v]) => (this.params[k] = v));
      }
      this.fetchData();
    },
    handleLpDatePickerChange(time) {
      this.time =
        time[0] && time[1]
          ? [new Date(time[0]).getTime(), new Date(time[1]).getTime()]
          : [];
    },
  },
};
